module.exports = __webpack_public_path__ + "img/preview-17.34a5d1c5.png";